class Animations {
  constructor() {
    this.events();
  }

  events() {
    window.addEventListener("scroll", () => this.reveal());
  }

  reveal() {
    let reveals = document.querySelectorAll(".reveal");
    reveals.forEach((el) => {
      let windowHeight = window.innerHeight;
      let elementTop = el.getBoundingClientRect().top;
      let elementVisible = 200;
      if (elementTop < windowHeight - elementVisible) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  }
}

export default Animations;
